import type { ReactElement } from 'react';

import { CountBadge } from '../CountBadge/CountBadge';
import { FormatNotSetCell } from '../DataTable/components/SlabTableRowCells';

export type TierEntry = {
  name: string;
  type: string;
};

export const TIER_TYPE_LABELS: Record<string, string> = {
  fixed: 'Price',
  tier: 'Tier',
  'list price': 'List',
};

export const formatTierLabel = (tier: TierEntry): string =>
  `${tier.name} (${TIER_TYPE_LABELS[tier.type] ?? tier.type})`;

export const TierBadges = ({ tiers }: { tiers: TierEntry[] | null }): ReactElement | null => {
  if (!tiers || tiers.length === 0) {
    return FormatNotSetCell(null) as ReactElement;
  }
  return <CountBadge entityName='Tier' entities={tiers.map(formatTierLabel)} />;
};
